export default {
  login: {
    title: 'Entrar',
    username: 'Nome de usuário',
    phone: 'Número de telefone',
    phoneCode: 'Código',
    email: 'E-mail',
    password: 'Senha',
    captcha: 'Captcha',
    loading: 'Carregando...',
    rememberMe: 'Lembrar-me',
    forgotPassword: 'Esqueceu a senha?',
    loginButton: 'Entrar',
    contactUs: 'Fale Conosco？',
    noAccount: 'Não tem uma conta?',
    registerNow: 'Cadastrar',
    or: 'OU',
    orSignInWith: 'Ou entre com',
    methodUsername: 'Nome de usuário',
    methodPhone: 'Telefone',
    methodEmail: 'E-mail',
    usernameRequired: 'Nome de usuário é obrigatório',
    phoneRequired: 'Número de telefone é obrigatório',
    emailRequired: 'E-mail é obrigatório',
    passwordRequired: 'Senha é obrigatória',
    captchaRequired: 'Captcha é obrigatório',
    resetPassword: 'Redefinir Senha',
    resetStep1Hint: 'Digite seu número de telefone ou e-mail para receber um código de verificação.',
    useEmailInstead: 'Usar e-mail',
    usePhoneInstead: 'Usar telefone',
    sendCode: 'Enviar Código',
    resetStep2Hint: 'Um código de verificação foi enviado para',
    verificationCode: 'Código de Verificação',
    verificationCodeRequired: 'Código de verificação é obrigatório',
    resendIn: 'Reenviar em',
    resendCode: 'Reenviar Código',
    verify: 'Verificar',
    resetStep3Hint: 'Defina sua nova senha.',
    newPassword: 'Nova Senha',
    confirmPassword: 'Confirmar Senha',
    passwordMinLength: 'A senha deve ter pelo menos 6 caracteres',
    confirmPasswordRequired: 'Por favor, confirme sua senha',
    passwordMismatch: 'As senhas não coincidem',
    resetPasswordBtn: 'Redefinir Senha',
    back: 'Voltar',
    // Format validation
    emailFormat: 'Formato de e-mail inválido',
    // Toast messages
    loginSuccess: 'Login realizado com sucesso',
    loginFailed: 'Falha no login',
    signInWithGoogle: 'Entrar com Google+',
    codeSent: 'Código de verificação enviado',
    sendCodeFailed: 'Falha ao enviar código',
    invalidCode: 'Código de verificação inválido',
    resetSuccess: 'Senha redefinida com sucesso',
    resetFailed: 'Falha ao redefinir a senha'
  }
};
